// extracted by mini-css-extract-plugin
module.exports = {"smwhb66":"smwhb66"};